import { analytics } from "FirebaseConfigs";
import { useSyncedState } from "hooks/useSyncedState";
import { AnalyticsEvent } from "models/AnalyticsEvent";
import { IconButton } from "@material-ui/core";
import Snackbar from '@material-ui/core/Snackbar';
import { Close } from "@material-ui/icons";
import Alert from "@material-ui/lab/Alert";
import React from "react";

type Props = {
    success?: string
    error?: string
    successEvent?: AnalyticsEvent
    errorEvent?: AnalyticsEvent
}

function Bar(severity: 'success' | 'error', setMessage: (message?: string) => void, message?: string, event?: AnalyticsEvent) {
    return (
        <Snackbar open>
            <Alert
                severity={severity}
                elevation={6}
                action={
                    <IconButton
                        edge="end"
                        size="small"
                        color="inherit"
                        onClick={() => {
                            if (event) {
                                analytics.logEvent(event)
                            }
                            setMessage('')
                        }}>
                        <Close />
                    </IconButton>
                }>
                {message}
            </Alert>
        </Snackbar>
    )
}

export function Snacbars({ error, success, errorEvent, successEvent }: Props) {
    const [successMessage, setSuccessMessage] = useSyncedState(success)
    const [errorMessage, setErrorMessage] = useSyncedState(error)
    return (
        <>
            {errorMessage ? (
                Bar('error', setErrorMessage, errorMessage, errorEvent)
            ) : null}
            {successMessage ? (
                Bar('success', setSuccessMessage, successMessage, successEvent)
            ) : null}
        </>
    )
}
